import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import SupportTable from "./Component/Option/SupportTable";
import SpecialtyTable from "./Component/Option/SpecialtyTable";
import AccreditationTable from "./Component/Option/AccreditationTable";
import UploadAgreementFileTable from "./Component/Option/UploadAgreementFileTable";
import LanguageTable from "./Component/Option/LanguageTable";
// import AppTabs from 'components/CustomTabs/AppTabs';
import { SYSTEM_ROLE } from 'config/AppConfig';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getAuthInfo } from 'store/slices/auth';
import ScrollableTabs from 'components/CustomTabs/AppTabsScroll';

const OptionManagement = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const userInfo = useSelector(getAuthInfo);

  useEffect(() => {
    if (userInfo.role !== SYSTEM_ROLE.COMPANY) {
      history.push('/');
      return;
    }
  }, []);

  const tabs = [
    {
      id: 1,
      title: t('label.support'),
      component: SupportTable
    },
    {
      id: 2,
      title: t('label.specialty'),
      component: SpecialtyTable
    },
    {
      id: 3,
      title: t('label.accreditation'),
      component: AccreditationTable
    },
    {
      id: 4,
      title: t('label.language'),
      component: LanguageTable
    },
    {
      id: 5,
      title: t('label.agreementFile'),
      component: UploadAgreementFileTable
    }
  ];

  if (userInfo.role !== SYSTEM_ROLE.COMPANY) {
    return null;
  }

  return (
    <ScrollableTabs
      swipeable={false}
      tabs={tabs.map(item => {
        const {
          title,
          component: Component
        } = item;
        return {
          tabLabel: title,
          tabContent: <Component />
        }
      })}
    />
    // <AppTabs
    //   swipeable={false}
    //   tabs={tabs.map(item => {
    //     const {
    //       title,
    //       component: Component
    //     } = item;
    //     return {
    //       tabLabel: title,
    //       tabContent: <Component />
    //     }
    //   })}
    // />
  )
}

export default OptionManagement;
